import { environment } from 'src/environments/env'

export function buildHeadshotUrl(headshot?: string, fallback: string = '/assets/default-avatar.png'): string {
  if (!headshot || headshot.includes('default-avatar')) {
    return fallback
  }

  const headshotId = headshot.replace(/\.[^.]+$/, '')
  return `${environment.apiUrl}/users/${headshotId}/headshot`
}
